import React from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {Placement} from 'react-bootstrap/types';

interface CustomTooltipProps {
    message: string;
    placement?: Placement;
    children: any;
    tooltipId?: string;
    hideOn?: boolean;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
                                                         message,
                                                         placement = 'top',
                                                         tooltipId = 'custom-tooltip',
                                                         children,
                                                         hideOn = false
                                                     }) => (
    hideOn ? children :
    <OverlayTrigger
        placement={placement}
        overlay={
            <Tooltip id={tooltipId}>
                {message}
            </Tooltip>
        }
    >
        {children}
    </OverlayTrigger>
);

export default CustomTooltip;
